import config from 'syft-acp-core/config'

export const APPLICATION_ID = `SyftApp-Admin ${config.appVersion}`
